import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { setDental } from './actions';

const dentalSelector = (state) => {
  return state.dental;
};

export const useDental = {
  state: () => {
    return useSelect(dentalSelector);
  },
  actions: () => {
    return {
      setDental: useAction(setDental),
    };
  },
};
